import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultSettingUpPlanData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'setting-up-plan-list',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'item-1',
              type: 'PresentationListItem',
              props: {
                title: 'Gather key information',
                description:
                  'Collect family details, a full list of assets and liabilities, and current family/beneficiary information to form the foundation of your plan.',
                iconType: 'number',
                iconColor: 'PRIMARY',
                number: 1,
              },
            },
            {
              id: 'item-2',
              type: 'PresentationListItem',
              props: {
                title: 'Define your objectives',
                description:
                  'Clarify who should receive your assets, when, and how. Decide on guardians for minor children, set family and charitable giving priorities, and outline privacy and tax goals.',
                iconType: 'number',
                iconColor: 'PRIMARY',
                number: 2,
              },
            },
            {
              id: 'item-3',
              type: 'PresentationListItem',
              props: {
                title: 'Prepare core and advanced documents',
                description:
                  'Work with an attorney to create or update your will, revocable living trust, powers of attorney, and healthcare directives. Where appropriate, also prepare additional documents to further your wealth transfer goals — such as irrevocable trusts, trusts for children or grandchildren, or other specialized structures that align with your estate planning strategy.',
                iconType: 'number',
                iconColor: 'PRIMARY',
                number: 3,
              },
            },
            {
              id: 'item-4',
              type: 'PresentationListItem',
              props: {
                title: 'Review beneficiary designations',
                description:
                  'Ensure retirement accounts, life insurance, and payable-on-death accounts reflect your current wishes and coordinate with your estate plan.',
                iconType: 'number',
                iconColor: 'PRIMARY',
                number: 4,
              },
            },
            {
              id: 'item-5',
              type: 'PresentationListItem',
              props: {
                title: 'Align asset titling',
                description:
                  'Check that deeds, account ownership, and entity interests match your intended distribution plan and trust structures.',
                iconType: 'number',
                iconColor: 'PRIMARY',
                number: 5,
              },
            },
            {
              id: 'item-6',
              type: 'PresentationListItem',
              props: {
                title: 'Implement tax and wealth transfer strategies',
                description:
                  'Work with your advisors to apply techniques such as lifetime gifting, generation-skipping transfer tax exemption allocation, valuation discounts, and charitable planning to reduce taxes and preserve wealth.',
                iconType: 'number',
                iconColor: 'PRIMARY',
                number: 6,
              },
            },
            {
              id: 'item-7',
              type: 'PresentationListItem',
              props: {
                title: 'Implement and store documents',
                description:
                  'Sign and notarize as required by state law, store documents securely, and inform key individuals where to find them.',
                iconType: 'number',
                iconColor: 'PRIMARY',
                number: 7,
              },
            },
            {
              id: 'item-8',
              type: 'PresentationListItem',
              props: {
                title: 'Review and update your plan regularly',
                description:
                  'Revisit your plan after major life events, significant changes in asset values, or shifts in tax law — at least every 3-5 years.',
                iconType: 'number',
                iconColor: 'PRIMARY',
                number: 8,
              },
            },
          ],
        },
      },
    ],
  };
}
